import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=52777c4e&scoped=true"
import script from "./EditInfo.vue?vue&type=script&lang=js"
export * from "./EditInfo.vue?vue&type=script&lang=js"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=52777c4e&prod&lang=less&scoped=true"
import style1 from "./EditInfo.vue?vue&type=style&index=1&id=52777c4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52777c4e",
  null
  
)

export default component.exports